module.exports = __webpack_public_path__ + "static/media/30316.04dbe208.jpg";